// extracted by mini-css-extract-plugin
export default {"normal":"btn-pure_normal__o7h4R","stretch":"btn-pure_stretch__Ddu2e","dark":"btn-pure_dark__oU7+f","selected":"btn-pure_selected__qJ6Lj"};